import { useEffect } from 'react';
import Close from '../Close';

interface ISidebarDrawerProps {
  onClose: (visible: boolean) => void;
  children: React.ReactNode;
  visible: boolean;
  title?: string;
  subtitle?: string;
  wrapperClassName?: string;
}

const SidebarDrawer = ({
  onClose,
  children,
  visible,
  title,
  wrapperClassName = '',
  subtitle,
}: ISidebarDrawerProps) => {
  useEffect(() => {
    if (visible === true) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [visible]);

  return (
    <main
      className={`fixed overflow-hidden z-[62] bg-gray-900 bg-opacity-25 inset-0 transform ease-in-out ${
        visible
          ? ' transition-opacity opacity-100 duration-500 translate-x-0'
          : ' transition-all delay-500 opacity-0 translate-x-full  '
      }`}
    >
      <section
        className={
          ` w-screen right-0 absolute bg-white h-full shadow-xl delay-400 duration-500 ease-in-out transition-all transform ${wrapperClassName}` +
          (visible ? ' translate-x-0 ' : ' translate-x-full ')
        }
      >
        <article className="relative w-full flex flex-1 flex-col h-full">
          {/* Header */}
          <header className="flex w-full justify-between p-6 border-b border-b-reliableBlack10">
            <div>
              <h3 className="lg:text-[20px] text-[16px] font-bold text-reliableBlack90 uppercase">
                {title}
              </h3>
              {subtitle && <p className="text-reliableBlack80">{subtitle}</p>}
            </div>
            <button className="text-black" aria-label="close-button" onClick={() => onClose(false)}>
              <Close size={24} fill="#000" />
            </button>
          </header>
          {children}
        </article>
      </section>
      <section
        className=" w-screen h-full cursor-pointer"
        onClick={() => {
          onClose(false);
        }}
      ></section>
    </main>
  );
};

export default SidebarDrawer;
